import React from 'react'


export const Input = ({required = false, autoFocus = false, style = {}, className = '', flex='column', onBlur, min = undefined, max = undefined, multiple = false, checked = false, tabIndex, step, centered, placeholder, type, label, value = '', id, changeHandler, focusHandler, disabled = false, readonly = false}) => {

  return (
    label 
    ? <label className='input__label' style={{...style, flexDirection: flex}}>{label}
        <input className={`${className}`}
        disabled={disabled}
        autoFocus={autoFocus}
        tabIndex={tabIndex}
        checked={checked}
        required={required}
        min={min}
        max={max}
        placeholder={placeholder}
        readOnly={readonly}
        multiple={multiple}
        step={step}
        onBlur={onBlur}
        type={type || 'text'}
        value={value} 
        id={id}
        autoComplete="off"
        onFocus={focusHandler}
        onChange={changeHandler}/>
    </label>

    :<input className={`${className}`}
    type={type || 'text'}
    placeholder={placeholder}
    style={centered ? {...style, textAlign: 'center'} : style}
    disabled={disabled}
    tabIndex={tabIndex}
    multiple={multiple}
    autoFocus={autoFocus}
    checked={checked}
    required={required}
    min={min}
    max={max}
    readOnly={readonly}
    step={step}
    onBlur={onBlur}
    value={value}
    id={id}
    autoComplete="off"
    onFocus={focusHandler}
    onChange={changeHandler}/>
  )
}
